module.exports = __webpack_public_path__ + "img/JetSki.a7a9145c.png";